var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3883 15.0815L7.69595 12.3221C7.55099 12.1732 7.35418 12.0895 7.14895 12.0895C6.94371 12.0895 6.74691 12.1732 6.60195 12.3221C6.29935 12.6322 6.29935 13.1332 6.60195 13.4433L9.84516 16.7674C10.1478 17.0775 10.6366 17.0775 10.9392 16.7674L19.1481 8.35387C19.4506 8.04373 19.4506 7.54273 19.1481 7.23259C19.0031 7.08368 18.8063 7 18.6011 7C18.3958 7 18.199 7.08368 18.0541 7.23259L10.3883 15.0815Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 14,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3883 15.0815L7.69595 12.3221C7.55099 12.1732 7.35418 12.0895 7.14895 12.0895C6.94371 12.0895 6.74691 12.1732 6.60195 12.3221C6.29935 12.6322 6.29935 13.1332 6.60195 13.4433L9.84516 16.7674C10.1478 17.0775 10.6366 17.0775 10.9392 16.7674L19.1481 8.35387C19.4506 8.04373 19.4506 7.54273 19.1481 7.23259C19.0031 7.08368 18.8063 7 18.6011 7C18.3958 7 18.199 7.08368 18.0541 7.23259L10.3883 15.0815Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_219)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox_checked.b09323fd12ebf842e761a4be6d11ac53.svg";
export { ForwardRef as ReactComponent };